import {Component} from 'react';
import { doubleToStringMonthly, standardNumberFormat } from '../../objects/CommonUse/double_functions';
import SavingsPolicyOptions from './savings/datasets/savings_policy_options';
import setInvestmentText from './investments/objects/set_investment_text';


class ConductorDashboardDataCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, 
             selected: false,
        };
    }

    determineGainLossInfo(){
        this.gainLossClass = "text-right";
        if (this.props.portfolioInfo.totalGainLoss < 0){
            this.gainLossClass += " text-danger";
        }
        if (this.props.displayPercent === true){
            this.rateOfReturn = standardNumberFormat(this.props.portfolioInfo.rateOfReturn);
        }else{
            this.rateOfReturn = "";
        }
    }

    determineTableText(){
        this.blankLine = false;
         if (this.props.summaryLevel === "total"){
            this.totalLabel = this.props.portfolioInfo.accountLabel;
        }else{
            const accountType = this.props.portfolioInfo.accountType;
            const subType = this.props.portfolioInfo.subType;
            this.totalLabel = subType
            if (accountType === "investments"){
                if (subType !== "Total Amts"){
                    const investmentText = setInvestmentText(subType);
                    if (investmentText){
                        this.totalLabel = investmentText.headingText;
                    }
                }
            }else{
                const savingObj = SavingsPolicyOptions.find(elem => elem.type === subType);
                if (savingObj){
                    this.totalLabel = savingObj.longName;
                }
                if (subType === "Total Amts"){
                    this.blankLine = true;
                }
                if (this.props.portfolioInfo.accountLabel === "401(k) Company Match"){
                    if (savingObj){
                        this.totalLabel = savingObj.type + "-Company Match";
                    }else{
                        this.totalLabel = "Total Match Amounts"
                    }
                }
            }
        }
    }
  
    render() {
        this.determineGainLossInfo();
        this.determineTableText();
    return <>
        <tr>
            <th className="text-left">{this.totalLabel}</th>
            {+this.props.portfolioInfo.totalInitialValue  ?
                 <td className="text-right">
                    {doubleToStringMonthly(this.props.portfolioInfo.totalInitialValue)}</td>
            :
                <td className = "text-right">{this.props.portfolioInfo.totalInitialValue}</td>
            }
            {+this.props.portfolioInfo.totalCurrentValue  ?
                  <td className="text-right">
                    {doubleToStringMonthly(this.props.portfolioInfo.totalCurrentValue)}</td>
            :
                <td className = "text-right">{this.props.portfolioInfo.totalCurrentValue}</td>              
            }
            <td className={this.gainLossClass}>{doubleToStringMonthly(this.props.portfolioInfo.totalGainLoss)}</td>
            <td className="text-right">{this.rateOfReturn}%</td>
        </tr>
        {this.blankLine   ?
            <tr className="mt-2">
                <td colSpan="4">&nbsp;</td>
            </tr>    
        :
            null
        }  
    </>
    }



}

export default ConductorDashboardDataCard;